import { render } from "./ChurchView.vue?vue&type=template&id=09be66e7"
import script from "./ChurchView.vue?vue&type=script&lang=js"
export * from "./ChurchView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__